(function () {
  function hideBuyNowIfPromoExists() {
    const splideList = document.querySelector(".rebuy-widget .splide__list");

    if (splideList && splideList.children.length > 0) {
      const buyNowBtn = document.querySelector(
        ".form-quantity-and-buy-buttons .button--buy-now",
      );

      if (buyNowBtn) {
        buyNowBtn.remove();
      }
    } else {
      const splideList = document.querySelector(".rebuy-widget .splide__list");
      const buyNowBtn = document.querySelector(
        ".form-quantity-and-buy-buttons .button--buy-now",
      );

      if (splideList && buyNowBtn) {
        buyNowBtn.classList.remove("invisible");
      }
    }
  }

  const interval = setInterval(() => {
    hideBuyNowIfPromoExists();
  }, 500);

  setTimeout(() => clearInterval(interval), 10000);
})();